import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["output"];

    connect() {
        this.rangeElement = this.element.querySelector("input[type=range]");
        if (!this.rangeElement) { throw new Error("An <input type='range'> element is required") }

        if (!this.hasOutputTarget)
            throw new Error("An element with a [data-range-output-target] attribute is required");

        this.rangeElement.addEventListener("input", () => {
            this.outputTarget.innerHTML = this.rangeElement.value;
        });
        this.outputTarget.innerHTML = this.rangeElement.value;
    }
}
